// extracted by mini-css-extract-plugin
export var company = "homepageVideoCarousel-module--company--ff1b1";
export var container = "homepageVideoCarousel-module--container--8fa38";
export var customerWrap = "homepageVideoCarousel-module--customerWrap--88d04";
export var customerrow = "homepageVideoCarousel-module--customerrow--b823c";
export var image = "homepageVideoCarousel-module--image--1f51f";
export var imageWrap = "homepageVideoCarousel-module--imageWrap--6f86f";
export var imgContainer = "homepageVideoCarousel-module--imgContainer--78159";
export var innerrow = "homepageVideoCarousel-module--innerrow--d0087";
export var label = "homepageVideoCarousel-module--label--a3b00";
export var marquee = "homepageVideoCarousel-module--marquee--3819d";
export var name = "homepageVideoCarousel-module--name--77a80";
export var play = "homepageVideoCarousel-module--play--99600";
export var scroll = "homepageVideoCarousel-module--scroll--1d197";
export var wistiaVideo = "homepageVideoCarousel-module--wistiaVideo--da339";